import React from "react";
import "./BalloonEffect.css"; // Import the raw CSS

const Balloon = ({ left, delay, color }) => (
  <div
    className="balloon"
    style={{
      left: `${left}%`,
      animationDuration: "8s",
      animationDelay: `${delay}s`,
      animationTimingFunction: "ease-in-out",
    }}
  >
    <div
      style={{
        backgroundColor: color,
        width: "2rem",
        height: "2.5rem",
        borderRadius: "9999px",
        margin: "0 auto",
      }}
    ></div>
    <div
      style={{
        width: "2px",
        height: "1.25rem",
        backgroundColor: "#555",
        opacity: 0.4,
        margin: "0 auto",
        marginTop: "-2px",
      }}
    ></div>
  </div>
);

const balloonCount = {
  subtle: 12,
  normal: 30,
  big: 48,
};

const BalloonEffect = ({ intensity = "normal" }) => {
  if (intensity === "off") return null;

  const balloons = Array.from({ length: balloonCount[intensity] || 30 }, () => ({
    left: Math.random() * 90,
    delay: Math.random() * 8,
    color: ["#ec4899", "#facc15", "#60a5fa", "#a78bfa"][
      Math.floor(Math.random() * 4)
    ],
  }));

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-10">
      {balloons.map((b, i) => (
        <Balloon key={i} {...b} />
      ))}
    </div>
  );
};

export default BalloonEffect;
